import { useState } from 'react';
import { homeFaqs } from '../../../mocks/faqs';

export default function FAQSection() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-24 bg-parkside-warm">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 items-start">
          {/* Left sticky header */}
          <div className="lg:col-span-2 lg:sticky lg:top-32">
            <span className="inline-block bg-parkside-amber/12 text-parkside-amber text-xs font-bold uppercase tracking-widest px-3.5 py-1.5 rounded-full mb-4">
              Voice Search Optimized
            </span>
            <h2 className="font-display text-4xl md:text-5xl text-parkside-dark mb-5 tracking-display leading-tight">
              Frequently Asked Questions
            </h2>
            <p className="text-parkside-muted text-base leading-relaxed mb-6">
              Everything you need to know about paver installation in Tampa Bay. Can&apos;t find your answer? Just call us.
            </p>
            <div className="bg-parkside-cream rounded-2xl p-6 border border-stone-100">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 flex items-center justify-center bg-parkside-green/15 rounded-xl">
                  <i className="ri-phone-fill text-parkside-green text-lg" />
                </div>
                <div>
                  <p className="text-xs font-bold uppercase tracking-wider text-parkside-stone">Questions? Call us</p>
                  <a href="tel:813-404-6313" className="text-parkside-dark font-bold text-lg hover:text-parkside-green transition-colors cursor-pointer">
                    (813) 404-6313
                  </a>
                </div>
              </div>
              <p className="text-parkside-stone text-xs">Mon–Sat, 8am–6pm. We typically respond to online inquiries within 24 hours.</p>
            </div>
          </div>

          {/* Right FAQ accordion */}
          <div className="lg:col-span-3 space-y-2">
            {homeFaqs.map((faq, idx) => (
              <div
                key={idx}
                className={`rounded-2xl border overflow-hidden transition-all duration-200 ${
                  openIdx === idx
                    ? 'border-parkside-green/30 bg-white'
                    : 'border-stone-100 bg-white hover:border-stone-200'
                }`}
              >
                <button
                  className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer group"
                  onClick={() => setOpenIdx(openIdx === idx ? null : idx)}
                >
                  <div className="flex items-start gap-3">
                    <div className={`w-6 h-6 flex items-center justify-center rounded-full flex-shrink-0 mt-0.5 transition-colors ${
                      openIdx === idx ? 'bg-parkside-green text-white' : 'bg-parkside-cream text-parkside-muted group-hover:bg-parkside-green/15'
                    }`}>
                      <i className="ri-question-line text-xs" />
                    </div>
                    <span className="text-parkside-dark font-semibold text-sm leading-snug">{faq.question}</span>
                  </div>
                  <span className="w-7 h-7 flex items-center justify-center flex-shrink-0 rounded-full bg-parkside-cream">
                    <i className={`text-parkside-green text-sm transition-transform duration-200 ${
                      openIdx === idx ? 'ri-subtract-line' : 'ri-add-line'
                    }`} />
                  </span>
                </button>

                {openIdx === idx && (
                  <div className="px-6 pb-6">
                    <div className="ml-9 border-l-2 border-parkside-green/30 pl-4">
                      <p className="text-parkside-muted text-sm leading-relaxed">{faq.answer}</p>
                    </div>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
